import { DottedMenu } from "../dotted-menu";
import { FC } from "react";
import { FileItemProps } from "../../types";
import { ExpirationTooltip } from "../expiration-tooltip";
import { ExtensionFileIcon } from "../extension-file-icon";
import style from "../style.module.scss";
// import { Thumbnail } from "../thumbnail";

export const FileItem: FC<FileItemProps> = (props) => {
  const {
    item,
    moveFileActionAllowed,
    showRemoveModal,
    showRenameModal,
    showMoveModal,
    showPreviewModal,
  } = props;
  const {
    key,
    fileName,
    formattedLastModified,
    formattedSizeName,
    expirationDays,
    formattedExpirationDate,
    fileExtensionType,
    thumbnail,
    fileExtension,
  } = item;

  const handleDeleteAction = async () =>
    showRemoveModal({ name: fileName, path: key, isFolder: false, thumbnail });

  const handleRenameAction = async () => {
    showRenameModal({ path: key, isFolder: false, name: fileName });
  };

  const handleMoveAction = async () => {
    showMoveModal({ name: fileName, path: key, isFolder: false });
  };

  const handlePreviewAction = async () => {
    await showPreviewModal({ fileName, fileExtension, fileExtensionType });
  };

  return (
    <div className={`${style.grid} ${style["grid-item"]}`}>
      <div className="text-light" style={{ maxWidth: 450 }}>
        <div className="d-flex align-items-center gap-2">
          {/* Disable thumbnail for 400 bad request */}
          {/* {thumbnail ? (
            <Thumbnail
              url={thumbnail}
              filename={fileName}
              fileExtensionType={fileExtensionType}
            />
          ) : ( */}
          <ExtensionFileIcon fileExtensionType={fileExtensionType} />
          {/* )} */}
          <p className="text-truncate">{fileName}</p>
          {expirationDays && expirationDays < 20 && (
            <ExpirationTooltip
              expirationDays={expirationDays ?? 99}
              formattedExpirationDate={formattedExpirationDate || ""}
            />
          )}
        </div>
      </div>
      <p className="text-light">{formattedLastModified}</p>
      <p className="text-light">{formattedSizeName}</p>
      <DottedMenu
        id={`dottedMenu-${fileName}`}
        actions={[
          {
            label: "Anteprima",
            action: handlePreviewAction,
            tooltipDisabledMessage:
              fileExtensionType === "image" || fileExtensionType === "pdf"
                ? undefined
                : "Anteprima non disponibile per questo tipo di file",
          },
          {
            label: "Sposta",
            action: handleMoveAction,
            tooltipDisabledMessage: moveFileActionAllowed
              ? undefined
              : "Non ci sono cartelle dove spostare il file",
          },
          { label: "Elimina", action: handleDeleteAction },
          { label: "Rinomina", action: handleRenameAction },
        ]}
      />
    </div>
  );
};
